var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddEnrol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23018 12.6718C5.02685 12.6718 2.29102 13.156 2.29102 15.096C2.29102 17.036 5.01018 17.5376 8.23018 17.5376C11.4343 17.5376 14.1693 17.0526 14.1693 15.1135C14.1693 13.1743 11.451 12.6718 8.23018 12.6718Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22969 9.9049C10.3322 9.9049 12.0364 8.20073 12.0364 6.09823C12.0364 3.99573 10.3322 2.29156 8.22969 2.29156C6.12802 2.29156 4.42385 3.99573 4.42385 6.09823C4.41635 8.19323 6.10802 9.8974 8.20385 9.9049H8.22969Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0026 7.22424V10.5659",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7072 8.895H14.2988",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddEnrol);
export default __webpack_public_path__ + "static/media/ic-add-enrol.973f6269dee7b1fc794ce91755675d5e.svg";
export { ForwardRef as ReactComponent };